import { render, staticRenderFns } from "./ManageCustomers.vue?vue&type=template&id=669e4ed4&scoped=true&"
import script from "./ManageCustomers.vue?vue&type=script&lang=js&"
export * from "./ManageCustomers.vue?vue&type=script&lang=js&"
import style0 from "./ManageCustomers.vue?vue&type=style&index=0&id=669e4ed4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "669e4ed4",
  null
  
)

export default component.exports